module.exports = __webpack_public_path__ + "images/category_lp/camera/graph_e58b17df169749141c60a8d8fa52415f.png";